import styles from "./index.module.less";
export default function checkinResult() {
  return (
    <div className={styles.wrapper}>
      <img className={styles.img} src={require('../../assets/img_finished.png').default} alt="图" />
      <span className={styles.text}>签到完成</span>
    </div>
  )
}